__turbopack_context__.v({
  "ArticleAccordion": "NtMHxa_ArticleAccordion",
  "ArticleAuthors": "NtMHxa_ArticleAuthors",
  "ArticleByline": "NtMHxa_ArticleByline",
  "ArticleContent": "NtMHxa_ArticleContent",
  "ArticleDivider": "NtMHxa_ArticleDivider",
  "ArticleItem": "NtMHxa_ArticleItem",
  "ArticleList": "NtMHxa_ArticleList",
  "ArticleList--Small": "NtMHxa_ArticleList--Small",
  "ArticlePreamble": "NtMHxa_ArticlePreamble",
  "ArticleSources": "NtMHxa_ArticleSources",
  "ArticleSourcesItem": "NtMHxa_ArticleSourcesItem",
  "ArticleSourcesList": "NtMHxa_ArticleSourcesList",
  "ArticleSourcesTitle": "NtMHxa_ArticleSourcesTitle",
  "ArticleTags": "NtMHxa_ArticleTags",
  "ArticleText": "NtMHxa_ArticleText",
  "ArticleTitle": "NtMHxa_ArticleTitle",
  "ArticleTop": "NtMHxa_ArticleTop",
  "ArticleTopBar": "NtMHxa_ArticleTopBar",
  "ArticleTopBarLeft": "NtMHxa_ArticleTopBarLeft",
  "ArticleTopBarRight": "NtMHxa_ArticleTopBarRight",
  "ArticleUpdated": "NtMHxa_ArticleUpdated",
  "BackButton": "NtMHxa_BackButton",
  "BookmarkDesktop": "NtMHxa_BookmarkDesktop",
  "BookmarkMobile": "NtMHxa_BookmarkMobile",
  "Container": "NtMHxa_Container",
  "Container--ArticleList": "NtMHxa_Container--ArticleList",
  "Container--SearchResultList": "NtMHxa_Container--SearchResultList",
  "Content": "NtMHxa_Content",
  "Filter": "NtMHxa_Filter",
  "GraphSection": "NtMHxa_GraphSection",
  "GraphTitle": "NtMHxa_GraphTitle",
  "Label": "NtMHxa_Label",
  "LayoutWrapper": "NtMHxa_LayoutWrapper",
  "Left": "NtMHxa_Left",
  "Main": "NtMHxa_Main",
  "MapWrapper": "NtMHxa_MapWrapper",
  "Right": "NtMHxa_Right",
  "Root": "NtMHxa_Root",
  "RootWithGraphs": "NtMHxa_RootWithGraphs",
  "SearchResultCount": "NtMHxa_SearchResultCount",
  "SearchResultList": "NtMHxa_SearchResultList",
  "SearchResultNumber": "NtMHxa_SearchResultNumber",
  "SearchResultText": "NtMHxa_SearchResultText",
  "SearchResultTextWrapper": "NtMHxa_SearchResultTextWrapper",
  "SearchRight": "NtMHxa_SearchRight",
  "SkeletonLoader": "NtMHxa_SkeletonLoader",
  "SkeletonLoaderText": "NtMHxa_SkeletonLoaderText",
  "TopWrapper": "NtMHxa_TopWrapper",
  "skeleton-loading": "NtMHxa_skeleton-loading",
});
